module.exports = __webpack_public_path__ + "static/media/Sun-19_moon-19.a9ee3423.png";